import React, { useLayoutEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { Divider, FormInstance, Switch } from 'antd';
import { Catcher } from '../../';
import { AdvancedField, IAdvancedField } from './AdvancedField';
import { ToggleListMyAlarm } from './ToggleListMyAlarm';
import { isTrueOnFields } from './index';
import { globalHexId } from '../../../instruments';
import { ITrField, tF } from '../../../translate';
import Styles from '../../styles/m_itemCardStyles.less';

interface IPanelTogglesControlMyAlarm {
    advancedField?: IAdvancedField[];
    form: FormInstance;
    isLoading?: boolean;
    isSending?: boolean;
    mainToggleLabel?: ITrField;
    togglesFields: ITrField[];
}

export const PanelTogglesControlMyAlarm: React.FC<IPanelTogglesControlMyAlarm> = observer(
    ({ togglesFields, isLoading, isSending, mainToggleLabel, advancedField, form }) => {
        const [isOpen, setIsOpen] = useState<boolean>(true);
        const [nonSelectedField] = useState<string>(globalHexId.getId() + '_nonSelectedField');
        const isLoadingEnabled = isLoading || isSending;
        const allFieldNames: string[] = [
            ...(advancedField?.map((af: IAdvancedField) => af.name) || []),
            ...togglesFields,
        ];
        const mainToggleLabelText = mainToggleLabel ? tF(mainToggleLabel) : '';
        useLayoutEffect(() => {
            setTimeout(() => {
                setIsOpen(isTrueOnFields(form, allFieldNames));
            }, 500);
        }, []);

        const handleMainToggle = (checked: boolean) => {
            setIsOpen(checked);
            if (checked) {
                form.resetFields(allFieldNames);
            } else {
                allFieldNames.forEach((fieldName: string) => {
                    form.setFieldValue(fieldName, undefined);
                });
            }
        };

        return (
            <Catcher>
                {mainToggleLabel ? (
                    <div className={Styles.panelTogglesMainToggles}>
                        <label>{mainToggleLabelText}</label>
                        <Switch loading={isLoadingEnabled} checked={isOpen} onChange={handleMainToggle} />
                    </div>
                ) : null}
                {isOpen ? (
                    <>
                        {advancedField?.map((af: IAdvancedField, index: number) => (
                            <AdvancedField
                                key={`${af.name}-${index}`}
                                isLoading={af.isLoading || isLoadingEnabled}
                                label={af.label}
                                name={af.name}
                                placeholder={af.placeholder}
                                rules={af.rules}
                                type={af.type}
                            />
                        ))}
                        {advancedField?.length ? <Divider className={Styles.collapseContentDivider} /> : null}
                        <ToggleListMyAlarm
                            fields={togglesFields}
                            form={form}
                            isLoading={isLoading}
                            nonSelectedField={nonSelectedField}
                        />
                    </>
                ) : null}
            </Catcher>
        );
    },
);
